import ListItem from '@tiptap/extension-list-item'

export default ListItem.extend({
  addAttributes() {
    return {
      ...ListItem.config.addAttributes,
      listStyle: {
        default: 'disc',
        renderHTML: (attributes) => ({
          style: `list-style: ${attributes.listStyle}`,
        }),
      },
    }
  },
})
